module.exports = __webpack_public_path__ + "static/media/about.d794db38.jpg";